import { withImmutableActions } from "neetocommons/react-utils";
import { create } from "zustand";

import { INITIAL_QUERY_PARAM } from "./Customization/constants";

/** @type {import("neetocommons/react-utils").ZustandStoreHook} */
const useProductEmbedStore = create(
  withImmutableActions(set => ({
    isQueryParamsEnabled: false,
    queryParams: [INITIAL_QUERY_PARAM],
    queryParamsProps: {
      helpPopoverProps: {},
      label: "",
      keyPlaceholder: "",
      valuePlaceholder: "",
      addButtonLabel: "",
    },

    setProductEmbedState: set,
    setQueryParams: queryParams => set({ queryParams }),
  }))
);

export default useProductEmbedStore;
